import { TERRA_API_HOST } from "../api-hosts";
import { httpClient } from "./http-client";

export default class FeatureTypeService {
    async getAll(req){
        return httpClient({
            url: `feature-types/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        })
    }
    async get(req){
        return httpClient({
            url: `feature-types/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        })
    }
    async delete(req){
        return httpClient({
            url: `feature-types/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'delete',
            headers: req.headers,
        })
    }
    async put(req){
        return httpClient({
            url: `feature-types/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            data: req.body,
            method: 'put',
            headers: req.headers,
        })
    }
    async patch(req){
        return httpClient({
            url: `feature-types/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            data: req.body,
            method: 'patch',
            headers: req.headers,
        })
    }
    async post(req){
        return httpClient({
            url: `feature-types/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            data: req.body,
            method: 'post',
            headers: req.headers,
        })
    }
    async move(req) {
        return httpClient({
            url: `feature-types/move/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            data: req.body,
            method: 'post',
            headers: req.headers,
        })
    }
}
